import React from "react";
import Col from "./Col";
import Card from "./Card";
import CardBody from "./CardBody";
import { getSize } from "../../utils/size";
import { classnames, combinePrefixes } from "../../utils/text";

const ColCard = ({
  type = "default",
  size = "md", // lg, md, sm ,x-sm
  className = "",
  card = {},
  cardBody = {},
  children,
  ...props
}) => {
  return (
    <Col
      className={classnames(
        combinePrefixes(
          `col-card`,
          [type.toLowerCase(), getSize(size)],
          "",
          true
        ),
        className
      )}
      size={size}
      type={type}
      {...props}
    >
      <Card size={size} type={type} {...card}>
        <CardBody size={size} type={type} {...cardBody}>
          {children}
        </CardBody>
      </Card>
    </Col>
  );
};
export default ColCard;
